import React, { Component } from 'react'
import { connect } from 'react-redux'
import Modal from 'react-modal'
import * as properties from '../../constants/Properties'
import { setCreateTicketModal } from '../actions/modalActions'
import { toggleKeyboard } from '../../actions/layoutActions'
import PropTypes from 'prop-types'
import $ from 'jquery'
import { saveTicket, deleteTicket } from '../../actions/invoiceActions'
import * as general from '../../constants/General'
import * as resource from '../../constants/Resources'
import { getTranslation } from '../../actions/dataActions'
import { setConfirmModal } from '../../actions/generalActions'


class CreateTicketModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
    }

    this.cancelTap = this.cancelTap.bind(this);
    this.deleteTap = this.deleteTap.bind(this);
    this.approveTap = this.approveTap.bind(this);
    this.showKeyboard = this.showKeyboard.bind(this);
  }

  showKeyboard(event) {
    let initinput = event.target.value;
    this.props.toggleKeyboard(true, `#${event.target.id}`, event.target.name, null, [], false, event.target.value, initinput);
  }

  cancelTap() {
    this.props.setCreateTicketModal(false, 'default');
    const { createTicketModal } = this.props;
    const callback = createTicketModal.callback;
    if (callback && callback !== null) {
      callback.apply(this);
    }
  }

  minTap() {
    var date = $('#ValidEnd').val();
    var dateParts = date.split('/');
    var newDate = new Date(parseInt(dateParts[2], 10), parseInt(dateParts[1] - 1, 10), parseInt(dateParts[0], 10) - 1)
    $('#ValidEnd').val(newDate.getDate().toString().padStart(2, '0') + "/" + (newDate.getMonth() + 1).toString().padStart(2, '0') + "/" + newDate.getFullYear());
  }

  plusTap() {
    var date = $('#ValidEnd').val();
    var dateParts = date.split('/');
    var newDate = new Date(parseInt(dateParts[2], 10), parseInt(dateParts[1] - 1, 10), parseInt(dateParts[0], 10) + 1)
    $('#ValidEnd').val(newDate.getDate().toString().padStart(2, '0') + "/" + (newDate.getMonth() + 1).toString().padStart(2, '0') + "/" + newDate.getFullYear());
  }

  approveTap() {
    this.props.setConfirmModal(this.props.getTranslation(resource.MODAL_SAVE_TICKET), () => this.confirmSave(), null, null, null, null);
  }

  confirmSave() {
    const { createTicketModal, saveTicket } = this.props;
    const callback = createTicketModal.callback;
    fetch(`${general.API_URL_GET_NEW_TICKET_OBJECT}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'Context': 'CreateTicketModal:approveTap'
      }
    }).then(response => response.json())
      .then(async (json) => {
        let uses = $('#Uses')[0].innerHTML;
        let parts = uses.split("/");
        let maxUsage = null;
        if (parts[1] !== '∞') {
          maxUsage = parseInt(parts[1], 10);
        }
        json.MaxUse = maxUsage;
        json.TicketId = $('#TicketId').val();
        json.Barcode = $('#Barcode').val();
        json.ValidStart = $('#ValidStart').val().split("/").reverse().join("-") + "T00:00:00";
        json.ValidEnd = $('#ValidEnd').val().split("/").reverse().join("-") + "T00:00:00";

        saveTicket(json, null, ticket => {
          this.props.setCreateTicketModal(false, 'default');
          if (callback && callback !== null) {
            callback.apply(this);
          }
        });
      });
  }

  deleteTap() {
    this.props.setConfirmModal(this.props.getTranslation(resource.MODAL_DELETE_TICKET), () => this.confirmDelete(), null, null, null, null);
  }

  confirmDelete() {
    const { createTicketModal, deleteTicket } = this.props;
    const callback = createTicketModal.callback;
    fetch(`${general.API_URL_GET_NEW_TICKET_OBJECT}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'Context': 'CreateTicketModal:approveTap'
      }
    }).then(response => response.json())
      .then(async (json) => {
        json.TicketId = $('#TicketId').val();
        json.Barcode = $('#Barcode').val();
        deleteTicket(json, null, ticket => {
          this.props.setCreateTicketModal(false, 'default');
          if (callback && callback !== null) {
            callback.apply(this);
          }
        });
      });
  }


  Add() {
    let uses = $('#Uses')[0].innerHTML;
    let parts = uses.split("/");
    let usage = parseInt(parts[0], 10);
    if (parts[1] !== '∞') {
      let maxUsage = parseInt(parts[1], 10);
      maxUsage++;
      uses = usage + '/' + maxUsage;
      $('#Uses')[0].innerHTML = uses;
    }
  }

  Reduce() {
    let uses = $('#Uses')[0].innerHTML;
    let parts = uses.split("/");
    let usage = parseInt(parts[0], 10);
    if (parts[1] !== '∞') {
      let maxUsage = parseInt(parts[1], 10);
      if (maxUsage <= usage || maxUsage <= 1) {
        return;
      }
      maxUsage--;
      uses = usage + '/' + maxUsage;
      $('#Uses')[0].innerHTML = uses;
    }
  }

  render() {
    let json = this.props.createTicketModal.ticket;
    let dateOfBirth = '';
    let validStart = '';
    let validEnd = '';
    let ticketId = '';
    let barcode = '';
    let description = '';
    let customerName = '';
    let street = '';
    let houseNumber = '';
    let zipCode = '';
    let city = '';
    let used = '';
    let maxUse = '';
    let address = '';
    let uses = ''
    if (json !== null && json !== undefined) {
      dateOfBirth = ((json.CustomerDateOfBirth !== null && json.CustomerDateOfBirth !== undefined) ? json.CustomerDateOfBirth : "").split(" ")[0].split("-").join("/");
      validStart = ((json.ValidStart !== null && json.ValidStart !== undefined) ? json.ValidStart : "").split("T")[0].split("-").reverse().join("/");
      validEnd = ((json.ValidEnd !== null && json.ValidEnd !== undefined) ? json.ValidEnd : "").split("T")[0].split("-").reverse().join("/");
      ticketId = (json.TicketId);
      barcode = ((json.Barcode !== null && json.Barcode !== undefined) ? json.Barcode : "");
      description = ((json.Description !== null && json.Description !== undefined) ? json.Description : "");
      customerName = ((json.CustomerName !== null && json.CustomerName !== undefined) ? json.CustomerName : "");
      street = ((json.Street !== null && json.Street !== undefined) ? json.Street : "");
      houseNumber = ((json.HouseNumber !== null && json.HouseNumber !== undefined) ? json.HouseNumber : "");
      zipCode = ((json.ZipCode !== null && json.ZipCode !== undefined) ? json.ZipCode : "");
      city = ((json.City !== null && json.City !== undefined) ? json.City : "");
      used = ((json.Used !== null && json.Used !== undefined) ? json.Used : "0");
      maxUse = ((json.MaxUse !== null && json.MaxUse !== undefined) ? json.MaxUse : '∞');
      address = street + ' ' + houseNumber;
      uses = used + '/' + maxUse;
    }
   

    return (
      <Modal className="createTicketModal" contentLabel=""
        isOpen={this.props.createTicketModal.show}
        style={properties.createTicketModalStyle}
        id="createTicketModal"
      >
        <div className="createTicketModal_header">
          <div className="header_top" id="createTicketTitle">
            {this.props.getTranslation(resource.TICKET)}
          </div>
        </div>
        <div className="createTicketModal_content">
          <input id="TicketId" type="text" style={{ display: 'none' }} name="TicketId" defaultValue={ticketId} />
          <div className="row">
            <div className="form-group field">
              <label>{this.props.getTranslation(resource.BARCODE)}</label>
              <input id="Barcode" className="createTicketModal_input" type="text" name={this.props.getTranslation(resource.BARCODE)} placeholder="" defaultValue={barcode} onClick={this.showKeyboard} />
            </div>
            <div className="field">
              <label>{this.props.getTranslation(resource.DESCRIPTION)}</label>
              <input disabled id="Description" className="createTicketModal_input" type="text" name={this.props.getTranslation(resource.DESCRIPTION)} placeholder="" defaultValue={description} onClick={this.showKeyboard} />
            </div>
          </div>
          <div className="row">
            <div className="field">
              <label>{this.props.getTranslation(resource.NAME)}</label>
              <input disabled id="CustomerName" className="createTicketModal_input" type="text" name={this.props.getTranslation(resource.NAME)} placeholder="" defaultValue={customerName} onClick={this.showKeyboard} />
            </div>
            <div className="field">
              <label>{this.props.getTranslation(resource.DATE_OF_BIRTH)}</label>
              <input disabled id="CustomerDateOfBirth" className="createTicketModal_input" type="text" name={this.props.getTranslation(resource.DATE_OF_BIRTH)} placeholder="dd/MM/yyyy" defaultValue={dateOfBirth} onClick={this.showKeyboard} />
            </div>
          </div>
          <div className="row">
            <div className="field">
              <label>{this.props.getTranslation(resource.ADDRESS)}</label>
              <input disabled id="Address" className="createTicketModal_input" type="text" name={this.props.getTranslation(resource.STREET)} placeholder="" defaultValue={address} onClick={this.showKeyboard} />
            </div>
            <div className="field">
              <label>{this.props.getTranslation(resource.ZIPCODE)}</label>
              <input disabled id="ZipCode" className="createTicketModal_input" type="text" name={this.props.getTranslation(resource.ZIPCODE)} placeholder="" defaultValue={zipCode} onClick={this.showKeyboard} />
            </div>
            <div className="field">
              <label>{this.props.getTranslation(resource.CITY)}</label>
              <input disabled id="City" className="createTicketModal_input" type="text" name={this.props.getTranslation(resource.CITY)} placeholder="" defaultValue={city} onClick={this.showKeyboard} />
            </div>
          </div>
          <div className="row">
            <div className="field">
              <label>{this.props.getTranslation(resource.VALID_FROM)}</label>
              <input id="ValidStart" className="createTicketModal_input" type="text" name={this.props.getTranslation(resource.VALID_FROM)} placeholder="dd/MM/yyyy" defaultValue={validStart} onClick={this.showKeyboard} />
            </div>
            <div className="field">
              <label>{this.props.getTranslation(resource.EXPIRES_ON)}</label>
              <input id="ValidEnd" className="createTicketModal_input" type="text" name={this.props.getTranslation(resource.VALID_TILL)} placeholder="dd/MM/yyyy" defaultValue={validEnd} onClick={this.showKeyboard} />
            </div>
            <button className="btnMin" onClick={this.minTap} >
              -
            </button>
            <button className="btnPlus" onClick={this.plusTap} >
              +
            </button>
          </div>
          <div className="row">
            <div className="card">
              <div className="card_header">
                <label>{this.props.getTranslation(resource.ENTRANCE_AND_EXITS)}</label>
              </div>
              <div className="card_content flex_column">
                <div className="card_content_header">
                  <label>{this.props.getTranslation(resource.DATE_AND_TIME)}</label>
                  <label>{this.props.getTranslation(resource.ENTRANCE_GATE)}</label>
                </div>
                <div className="border"></div>
                <div className="scrollable">
                  {this.props.createTicketModal.ticketusages === undefined ? '' :
                    this.props.createTicketModal.ticketusages.map(tick =>
                      <div key={tick.TicketUsageId} className="row">
                        <div className="card_data">{tick.UsageDate.replace("T", " ")}</div>
                        <div className="card_data"></div>
                      </div>)
                  }
                </div>
              </div>
            </div>
            <div className="card">
              <div className="card_header">
                <label>{this.props.getTranslation(resource.TICKET_USAGE)}</label>
              </div>
              <div className="card_content flex_row">
                <div id="Uses" className="createTicketModal_input">
                  {uses}
                </div>
                <div className="btn_container">
                  <button className="btnChange add" onClick={this.Add}>+</button>
                  <button className="btnChange reduce" onClick={this.Reduce}>-</button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="createTicketModal_footer">
          <button className="btnCancel" onClick={this.cancelTap} >
            {this.props.getTranslation(resource.CLOSE)}
          </button>
          <button className="btnDelete" onClick={this.deleteTap} >
            {this.props.getTranslation(resource.DELETE)}
          </button>
          <button className="btnApprove" onClick={this.approveTap} >
            {this.props.getTranslation(resource.SAVE)}
          </button>
        </div>
      </Modal>
    )
  }
}

CreateTicketModal.propTypes = {
  setCreateTicketModal: PropTypes.func.isRequired,
  saveTicket: PropTypes.func.isRequired,
  deleteTicket: PropTypes.func.isRequired,
  setConfirmModal: PropTypes.func,
}

function mapStateToProps(state) {
  return {
    createTicketModal: state.modalState.createTicketModal,
    posId: state.generalState.posId
  }
}

export default connect(mapStateToProps, {
  setCreateTicketModal,
  saveTicket,
  deleteTicket,
  toggleKeyboard,
  getTranslation,
  setConfirmModal
})(CreateTicketModal)



// WEBPACK FOOTER //
// src/modal/components/CreateTicketModal.jsx